import clsx from 'clsx'
import React from 'react'
import { CSSProperties } from 'react'

import styles from './styles.module.scss'

import { IconSvg } from '../../atoms'
import { breakpoints, useMediaQuery } from '../../../lib/hooks'

interface ITabsProps<T> {
  tabs: ITabProps<T>[]
  style?: CSSProperties
  styleLabel?: CSSProperties
  disabled?: boolean
  forceWebStyle?: boolean
  className?: string
  tabClassName?: string
}

export interface ITabProps<T> {
  label: string
  icon?: any
  value: T
  isLocked?: boolean
}

function TabsOta<T extends string>({
  tabs,
  style = {},
  styleLabel = {},
  disabled = false,
  forceWebStyle = false,
  className,
  tabClassName,
}: ITabsProps<T>) {
  const isMobile = useMediaQuery(breakpoints.newMobile)
  return (
    <div
      className={clsx(
        !isMobile || forceWebStyle
          ? styles.containerTabs
          : styles.mobileContainerTabs,
        className,
      )}
      style={style}
    >
      {tabs.map((tab) => {
        return (
          <div
            className={clsx(styles.containerTab, tabClassName, {
              //[styles.active]: tab.active,
              [styles.locked]: tab.isLocked || disabled,
            })}
            //onClick={() => !tab.isLocked && !disabled && onChangeActiveTab(tab.value)}
            key={tab.value}
          >
            {tab.icon && <div className={styles.iconTab}>{tab.icon}</div>}
            <span className={styles.labelTab} style={styleLabel}>
              {tab.label}
            </span>
            {tab.isLocked && (
              <div className={styles.iconLocked}>
                <IconSvg.Lock height={10} />
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default TabsOta
